import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const sectionTitle = css`
  font-family: ${font_family_weight_medium};
  ${font_md}
  color: ${text_colorTextPrimary};
`

export const subtle = css`
  font-family: ${font_family_weight_regular};
  ${font_sm}
  color: ${text_colorTextSecondary};
`

export const root = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
`

export const subtitle = css`
  ${subtle}
  margin: 0;
  max-width: 640px;
`

export const invitedSection = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
`

export const emptyCard = css`
  ${subtle}
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${cornerRadius};
  background: ${base_colorSurfaceSecondary};
  padding: ${spacing(4)};
`

export const staticPillClassName = 'BulkInviteReviewStep-staticPill'

export const summaryPills = css`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing(2)};

  .${staticPillClassName} {
    pointer-events: none;
  }
`

// Leading status icon + label inside a summary pill. The icon inherits the
// pill's text color via fill="currentColor".
export const pillContent = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(1)};

  svg {
    flex-shrink: 0;
  }
`

export const infoNotice = css`
  ${subtle}
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${cornerRadius};
  background: ${base_colorSurfaceSecondary};
  padding: ${spacing(3)} ${spacing(4)};
`

export const otherSection = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
`

export const otherTableWrap = css`
  margin-top: ${spacing(1)};
`

export const sendErrorDetail = css`
  margin-top: ${spacing(1)};
`
